module.exports = "/src/views/player/hudevo/ipad/assets/images/rent.png";